import { HttpMethod } from '@vision/ui/enums';
import { ApiResponse, JourneyMap } from '@vision/ui/interfaces';
import { buildEndpointWithQuery, createHttpExtraOptions } from '@vision/ui/utils';
import { JourneyMapApi } from './journey-map.api';

const JourneyMapListEndpoints = JourneyMapApi.injectEndpoints({
  endpoints: (builder) => ({
    getJourneyMaps: builder.query<ApiResponse<JourneyMap[]>, { accountId: string; query?: string }>({
      query: ({ accountId, query }) => ({
        url: buildEndpointWithQuery(`/v2/accounts/${accountId}/customer_journey_maps`, query),
        method: HttpMethod.GET,
      }),
    }),
    createJourneyMap: builder.mutation<ApiResponse<JourneyMap>, { accountId: string; name: string }>({
      query: ({ accountId, name }) => ({
        url: `/v2/accounts/${accountId}/customer_journey_maps`,
        method: HttpMethod.POST,
        data: {
          name,
          structure: {},
        },
        extraOptions: createHttpExtraOptions({
          notification: {
            translationMessageKey: 'http.message.journeyMap.create.{{status}}',
            autoHandleError: false,
          },
        }),
      }),
    }),
    deleteJourneyMap: builder.mutation<void, { accountId: string; journeyMapId: string }>({
      query: ({ accountId, journeyMapId }) => ({
        url: `/v2/accounts/${accountId}/customer_journey_maps/${journeyMapId}/delete`,
        method: HttpMethod.POST,
        extraOptions: createHttpExtraOptions({
          notification: {
            translationMessageKey: 'http.message.journeyMap.delete.{{status}}',
          },
        }),
      }),
    }),
    cloneJourneyMap: builder.mutation<ApiResponse<JourneyMap>, { accountId: string; journeyMapId: string }>({
      query: ({ accountId, journeyMapId }) => ({
        url: `/v2/accounts/${accountId}/customer_journey_maps/${journeyMapId}/clone`,
        method: HttpMethod.POST,
        extraOptions: createHttpExtraOptions({
          notification: {
            translationMessageKey: 'http.message.journeyMap.clone.{{status}}',
          },
        }),
      }),
    }),
  }),
});

export const {
  useGetJourneyMapsQuery,
  useLazyGetJourneyMapsQuery,
  useCreateJourneyMapMutation,
  useDeleteJourneyMapMutation,
  useCloneJourneyMapMutation,
} = JourneyMapListEndpoints;
